import { NameSpecifiedEntity } from "../../entity";

export class ReceptionTypeItem extends NameSpecifiedEntity<number> {
  constructor(id: number, name: string, public isDisable: boolean) {
    super(id, name);
  }
}
